/**
 * Environment Utilities
 *
 * Pure utility functions for environment detection.
 */

interface BrowserInfo {
	platform: {
		type: string
	}
	browser: {
		name: string
	}
}

/**
 * Checks if code is running on the server side
 * @returns true if running on server, false if running in browser
 */
export const isServer = (): boolean => typeof window === 'undefined'

/**
 * Gets browser information
 *
 * Note: This function currently returns null as browser detection
 * is no longer actively used. It was previously used for:
 * - IE detection for video fallbacks (IE is no longer supported)
 * - Server-side mobile detection (now handled by window width)
 *
 * Kept for backward compatibility with existing code that calls it.
 * The callers handle null gracefully with fallback behavior.
 *
 * @returns null - Browser detection is not currently implemented
 * @deprecated Consider removing usages if not needed
 */
export const getBrowser = (): BrowserInfo | null => null
